import React from "react";
import "./RadioButtons.css";

function RadioButtons({
  options,
  selectedOption,
  onChange,
  name,
  displayName,
  error,
  disabled = false,
  className = "",
}) {
  return (
    <div className={`input-container ${error ? "error" : ""}`}>
      <div className={`radio-buttons-container ${className}`}>
        {displayName && (
          <div className="radio-buttons-label App-text-medium">
            {displayName}*:
          </div>
        )}
        {options.map(option => {
          // Handle both simple strings and option objects with label/value
          const value = typeof option === "object" ? option.value : option;
          const label = typeof option === "object" ? option.label : option;

          return (
            <label className={"App-text-medium"} key={value}>
              <input
                type="radio"
                name={name}
                value={value}
                checked={selectedOption === value}
                onChange={() => onChange({ target: { name, value } })}
                disabled={disabled}
              />
              {label}
            </label>
          );
        })}
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default RadioButtons;
